import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { MtsType, MtsTypeCreate } from 'SharedDir/declarations/NomenclatureCatalogs/mts-type';
import { mtsTypeUrl } from 'SharedDir/backend/endpoints/nomenclature-catalogs';

export class MtsTypeApiClass extends SimpleApi<MtsType, MtsTypeCreate> {
  constructor() {
    super(mtsTypeUrl);
  }
}
